// eslint-disable-next-line no-restricted-imports
import CarrotClient from "#/lib/carrot-api"
import Settings from "./CarrotConfig"

export const carrotClient = new CarrotClient(Settings.CARROT_BACKEND_URL)
